import { cn } from '@/lib/utils';
import ffIcon from '@/client/assets/brand/ff-icon.png';
import jijiIcon from '@/client/assets/sales-sites/jiji.png';
import meqasaIcon from '@/client/assets/sales-sites/meqasa.png';
import gpcIcon from '@/client/assets/sales-sites/gpc.png';
import lamudiIcon from '@/client/assets/sales-sites/lamudi.jpg';
import privatePropertyIcon from '@/client/assets/sales-sites/privateproperty.png';
import { SHARE_SITE_COLOR, SHARE_SITE_LABEL, type ShareSiteId } from '../prospect-share';

const SRC: Partial<Record<ShareSiteId, string>> = {
  feelyfeely: ffIcon,
  jiji: jijiIcon,
  meqasa: meqasaIcon,
  gpc: gpcIcon,
  lamudi: lamudiIcon,
  privateproperty: privatePropertyIcon,
};

export function ShareSiteIcon({ id, className }: { id: ShareSiteId; className?: string }) {
  const src = SRC[id];
  if (src) {
    return (
      <img
        src={src}
        alt=""
        width={20}
        height={20}
        className={cn('h-5 w-5 shrink-0 rounded-sm object-contain', className)}
      />
    );
  }
  return (
    <span
      aria-hidden
      className={cn(
        'inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-sm text-[10px] font-semibold text-white',
        className,
      )}
      style={{ backgroundColor: SHARE_SITE_COLOR[id] }}
    >
      {(SHARE_SITE_LABEL[id] || '?').slice(0, 1)}
    </span>
  );
}

export function ShareSiteName({
  id,
  extra,
  className,
}: {
  id: ShareSiteId;
  extra?: React.ReactNode;
  className?: string;
}) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <ShareSiteIcon id={id} />
      <span>{SHARE_SITE_LABEL[id]}</span>
      {extra}
    </span>
  );
}
